var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("Key Handling")]),
    _vm._v(" "),
    _c(
      "ul",
      [
        _vm._v("\n    " + _vm._s(_vm.events) + "\n    "),
        _vm._l(_vm.events, function(event, index) {
          return _c("li", { key: "event-" + index }, [
            _vm._v("\n      KeyCode: " + _vm._s(event.keyCode) + " "),
            _c("br"),
            _vm._v("\n      Code: " + _vm._s(event.code) + " "),
            _c("br"),
            _vm._v("\n      Name: " + _vm._s(event.name) + "\n    ")
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8622454", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8622454","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoKeyHandling.vue
// module id = null
// module chunks = 